import badger from './badger.svg'
import carlo from './carlo.svg'
import darkHorse from './dark-horse.svg'
import apollo from './apollo.svg'
import prodigo from './prodigo.svg'
import ralph from './ralph.svg'
import xiaoXu from './xiao-xu.svg'

const avatarReference = {
  badger: badger,
  carlo: carlo,
  'dark horse': darkHorse,
  apollo: apollo,
  prodigo: prodigo,
  ralph: ralph,
  'xiao xu': xiaoXu,
}

export {
  badger,
  carlo,
  darkHorse,
  apollo,
  prodigo,
  ralph,
  xiaoXu,
  avatarReference,
}
